import { watch, type Ref } from 'vue';
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import { canEditFrequentation } from '@/views/planning/frequentation-access';

/** The enrolment list (Admission › Fréquentations). */
export const FREQUENTATION_LIST_ROUTE_NAME = 'planification-frequentations';

/**
 * Where a navigation to the enrolment list goes instead, or null to let it through.
 *
 * The list is staff only. A teacher opens one enrolment, read-only, from the student card of
 * Présences (#1443); for them the list does not exist — no rows, no « accès refusé » from its
 * staff-only calls — so a typed URL or an old link lands on their own dashboard (`home`). A
 * profile not loaded yet (cold start) is let through: the watch rejudges once it arrives.
 */
export function frequentationListRedirect(
    to: Pick<RouteLocationNormalizedLoaded, 'name'>,
    permissions: readonly string[] | undefined,
): { name: string } | null {
    if (to.name !== FREQUENTATION_LIST_ROUTE_NAME || permissions === undefined) return null;
    return canEditFrequentation(permissions) ? null : { name: 'home' };
}

/** Same installation pattern as `installGricsImportAvailability` (main.ts). */
export function installFrequentationListGuard(
    router: Router,
    me: Ref<{ permissions: string[] } | null | undefined>,
): void {
    router.beforeEach(to => frequentationListRedirect(to, me.value?.permissions) ?? true);

    watch(me, () => {
        const target = frequentationListRedirect(router.currentRoute.value, me.value?.permissions);
        if (target) void router.replace(target);
    });
}
